import { NgModule } from '@angular/core';
import { HeaderComponent } from './header/header.component';
import { FooterComponent } from './footer/footer.component';
import { ModalComponent } from './modal/modal.component';
import { ShareButtonsComponent } from './shareButtons/shareButtons.component';
import { ShareButtonsModalComponent } from './shareButtons/shareButtonsModal.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { BrowserModule } from '@angular/platform-browser';
import { ResponsiveModule } from '../responsive/responsive.module';
import { FormsModule } from '@angular/forms';
import { UIRouterModule } from '@uirouter/angular';
import { FormModule } from '../form/form.module';
import { ClickOutsideDirective } from './clickOutside/clickOutside.directive';
import { UuidService } from './uuid.service';
import { ShareButtonsService } from './shareButtons/shareButtons.service';
import { DownloadService } from './download/download.service';
import { CommonModule } from '@angular/common';
import { CookiesModule } from '../cookies/cookies.module';

@NgModule({
  declarations: [
    HeaderComponent,
    FooterComponent,
    ModalComponent,
    ShareButtonsComponent,
    ShareButtonsModalComponent,
    ClickOutsideDirective
  ],
  imports: [
    BrowserAnimationsModule,
    BrowserModule,
    ResponsiveModule,
    FormModule,
    FormsModule,
    UIRouterModule,
    CookiesModule,
    CommonModule
  ],
  providers: [
    UuidService,
    ShareButtonsService,
    DownloadService
  ],
  exports: [
    HeaderComponent,
    FooterComponent,
    ModalComponent,
    ShareButtonsComponent,
    ShareButtonsModalComponent,
    BrowserAnimationsModule,
    BrowserModule,
    FormsModule,
    FormModule,
    ClickOutsideDirective,
    CommonModule
  ]
})
export class GlobalModule {
}


// WEBPACK FOOTER //
// ./src/app/global/global.module.ts